import { render, staticRenderFns } from "./TeleconferenceSupport.vue?vue&type=template&id=18cef8e8&"
import script from "./TeleconferenceSupport.vue?vue&type=script&lang=js&"
export * from "./TeleconferenceSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports